import type Database from 'better-sqlite3';

export interface SnapshotRecord {
  id: number;
  snapshot_hash: string;
  files_count: number;
  total_size: number;
  created_at: number;
}

export class SnapshotsRepo {
  private readonly insertStmt = this.db.prepare(
    `INSERT INTO snapshots (snapshot_hash, files_count, total_size, created_at)
     VALUES (?, ?, ?, ?)`,
  );

  private readonly selectLatestStmt = this.db.prepare(
    `SELECT * FROM snapshots ORDER BY created_at DESC LIMIT 1`,
  );

  constructor(private readonly db: Database.Database) {}

  insert(
    snapshotHash: string,
    filesCount: number,
    totalSize: number,
    createdAt: number,
  ): void {
    this.insertStmt.run(snapshotHash, filesCount, totalSize, createdAt);
  }

  getLatest(): SnapshotRecord | undefined {
    return this.selectLatestStmt.get() as SnapshotRecord | undefined;
  }
}
